export default __webpack_public_path__ + "static/media/05.ad1b4da6.jpg";